<template>
  <div>
    <CommonOverlay @handleOverlayClick="$emit('close')" class="overlay_conf">
      <div @click.stop>
        <CommonModal @click.stop class="modal payment-modal">
          <!-- 口座もしくはペイパルの登録がない場合 -->
          <div class="modal-content" v-if="mode === 'register'">
            <div class="bank-info" v-if="selectedPaymentType == 0">
              <SubTitle class="subtitle">{{ t('口座情報') }}</SubTitle>
              <div
                class="form-group bank"
                :class="{ short: selectedPaymentType !== 0 }"
              >
                <label>{{ t('銀行名') }}</label>
                <div class="form-one">
                  <TextBox
                    class="text-box"
                    inputType="text"
                    v-model="paymentData.bank_name"
                  />
                </div>
              </div>
              <div
                class="form-group bank"
                :class="{ short: selectedPaymentType !== 0 }"
              >
                <label>{{ t('支店名') }}</label>
                <div class="form-one">
                  <TextBox
                    class="text-box"
                    inputType="text"
                    v-model="paymentData.bank_branch"
                  />
                </div>
              </div>
              <div
                class="form-group bank"
                :class="{ short: selectedPaymentType !== 0 }"
              >
                <label>{{ t('支店番号') }}</label>
                <div class="form-one">
                  <TextBox
                    class="text-box"
                    inputType="number"
                    v-model="paymentData.bank_branch_number"
                  />
                </div>
              </div>
              <div class="form-group bank ">
                <label>{{ t('口座種別') }}</label>
                <select v-model="paymentData.bank_account_type">
                  <option value="1">{{ t('普通') }}</option>
                  <option value="2">{{ t('当座') }}</option>
                </select>
              </div>
              <div class="form-group bank account-type">
                <label>{{ t('口座番号') }}</label>
                <div class="form-one">
                  <TextBox
                    class="text-box"
                    inputType="number"
                    v-model="paymentData.bank_account_number"
                  />
                </div>
              </div>
              <div class="form-group bank account-type">
                <label>{{ t('名義') }}</label>
                <div class="form-one">
                  <TextBox
                    class="text-box"
                    inputType="text"
                    v-model="paymentData.bank_account_name"
                  />
                </div>
              </div>
            </div>
            <div class="paypal" v-if="selectedPaymentType == 1">
              <div
                class="form-group"
                :class="{ short: selectedPaymentType !== 1 }"
              >
                <label>{{ t('メールアドレス') }}</label>
                <div class="form-one">
                  <TextBox
                    class="text-box"
                    inputType="text"
                    v-model="paymentData.paypal_email"
                  />
                </div>
              </div>
            </div>
            <ErrorMessage
              v-if="registerErrorMessage"
              :message="registerErrorMessage"
              class="error-message"
            />
            <div class="button-area">
              <button class="cancel" @click="$emit('close')">
                {{ t('キャンセル') }}
              </button>
              <BuyButton
                :isArrow="false"
                class="square-button"
                :text="t('保存する')"
                @handleSquareBtnClick="handleSave"
              />
            </div>
          </div>
          <!-- 振込先削除の確認モード -->
          <div class="modal-content" v-else-if="mode === 'attention'">
            <h2>{{ t('振込先情報を削除しますか？') }}</h2>
            <p>{{ t('この操作は取り消せません。よろしいですか？') }}</p>
            <div class="button-area">
              <button class="cancel" @click="mode = 'confirm'">
                {{ t('いいえ') }}
              </button>
              <BuyButton
                :isArrow="false"
                class="square-button"
                :text="t('はい')"
                @handleSquareBtnClick="confirmDeleteAccount"
              />
            </div>
          </div>
          <!-- 口座登録後のモーダル↓ -->
          <div class="modal-content" v-else-if="mode === 'confirm'">
            <h2>{{ t('申請確認') }}</h2>
            <div class="modal-body">
              <div class="payment-summary">
                <div class="detail-row">
                  <div class="summary-row app-amount">
                    <span class="label"> {{ t('申請振込金額') }} </span>
                    <span class="amount">
                      {{ paymentAmount | comma }} {{ t('円') }}
                    </span>
                  </div>
                  <div class="detail-item sub">
                    <span class="label">{{ t('振込手数料') }} :</span>
                    <span v-if="selectedPaymentType == 0" class="amount">{{ calcFee }}{{ t('円') }}</span>
                    <span v-if="selectedPaymentType == 1" class="amount paypal-text">{{ t('PayPalの手数料に準ずる') }}</span>
                  </div>
                  <div class="summary-row">
                    <span class="label">{{ t('振込金額') }} :</span>
                    <span v-if="selectedPaymentType == 0" class="amount">{{ calcTotalAmount | comma }}{{ t('円') }}</span>
                    <span v-if="selectedPaymentType == 1" class="amount paypal-text">{{ t('PayPalの手数料が差し引かれた後の金額') }}</span>
                  </div>
                </div>
              </div>
              <div v-if="selectedPaymentType == 0" class="info-header">
                <span class="section-title">{{ t('振込先情報') }}</span>
                <button class="delete-btn" @click="handleDeleteAccount">
                  削除
                </button>
              </div>
              <div
                class="detail-info"
                v-if="selectedPaymentType == 0 && selectedPaymentInfo"
              >
                <div class="detail-item">
                  <span class="label">{{ t('銀行名') }} :</span
                  >{{ selectedPaymentInfo.bank_name }}
                </div>
                <div class="detail-item">
                  <span class="label">{{ t('支店名') }} :</span
                  >{{ selectedPaymentInfo.bank_branch }}
                </div>
                <div class="detail-item">
                  <span class="label">{{ t('支店番号') }} :</span
                  >{{ selectedPaymentInfo.bank_branch_number }}
                </div>
                <div class="detail-item">
                  <span class="label">{{ t('口座番号') }} :</span
                  >{{ selectedPaymentInfo.bank_account_number }}
                </div>
                <div class="detail-item">
                  <span class="label">{{ t('名義') }} :</span
                  >{{ selectedPaymentInfo.bank_account_name }}
                </div>
              </div>

              <div
                class="detail-info"
                v-else-if="selectedPaymentType == 1 && selectedPaymentInfo"
              >
                <div class="detail-item">
                  <span class="label">{{ t('PayPalメールアドレス') }} :</span
                  >{{ selectedPaymentInfo.paypal_email }}
                </div>
              </div>
              <div v-if="selectedPaymentType == 0" class="check-item">
                <label
                  ><input type="checkbox" v-model="localQuickDeposit" />
                  {{ t('スピード入金を利用する(翌営業日の送金)') }}</label
                >
              </div>
            </div>
            <ErrorMessage
              v-if="confirmErrorMessage"
              :message="confirmErrorMessage"
              class="error-message"
            />
            <div class="button-area">
              <button class="cancel" @click="$emit('close')">
                {{ t('キャンセル') }}
              </button>
              <BuyButton
                :isArrow="false"
                class="square-button"
                :disabled="isSubmitDisabled"
                :text="t('申請する')"
                @handleSquareBtnClick="handleSubmit"
              />
            </div>
          </div>
        </CommonModal>
      </div>
    </CommonOverlay>
  </div>
</template>

<script>
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import SubTitle from '@/components/molecules/SubTitle.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import t from '@/plugins/i18n';
import { separateCharacterNumber } from '@/common/util/format';

export default {
  mixins: [t],
  components: {
    CommonOverlay,
    CommonModal,
    BuyButton,
    SubTitle,
    TextBox,
    ErrorMessage,
  },
  props: {
    paymentAmount: {
      type: Number,
      default: 0,
    },
    availableAmount: {
      type: Number,
      default: 0,
    },
    mode: {
      type: String,
      default: 'default',
    },
    selectedPaymentType: {
      type: [String, Number],
      default: 0,
    },
    selectedPaymentInfo: {
      type: Object,
      default: () => ({}),
    },
    paymentSaveErrorMessage: {
      type: Object,
      default: () => ({}),
    },
    paymentErrorMessage: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    const info = this.selectedPaymentInfo || {};
    return {
      localQuickDeposit: this.quickDeposit,
      postData: {
        user_payment_id: info.id || null,
        payment_amount: this.paymentAmount ?? 0,
        is_speed_payment: false,
        payment_type: this.selectedPaymentType ?? 0,
      },
      paymentData: {
        payment_type: this.selectedPaymentType ?? 0,
        bank_name: '',
        bank_branch: '',
        bank_account_number: '',
        bank_branch_number: '',
        bank_account_type: 1,
        bank_account_name: '',
        paypal_email: '',
      },
      errorMessage: {},
    };
  },
  computed: {
    calcFee() {
      if (this.localQuickDeposit) return 600;
      return this.paymentAmount <= 30000 ? 350 : 0;
    },
    calcTotalAmount() {
      return (this.paymentAmount || 0) - this.calcFee;
    },
    registerErrorMessage() {
      const e = this.paymentSaveErrorMessage || {};
      return (
        (e.bank && e.bank[0]) || (e.paypal && e.paypal[0]) || (e.system && e.system[0]) || (e.amount && e.amount[0]) || (e.user_payment && e.user_payment[0]) || ''
      );
    },
    confirmErrorMessage() {
      const e = this.paymentErrorMessage || {};
      return (
        (e.bank && e.bank[0]) || (e.paypal && e.paypal[0]) || (e.system && e.system[0]) || (e.amount && e.amount[0]) || (e.user_payment && e.user_payment[0]) || ''
      );
    },
    isSubmitDisabled() {
      return !this.paymentAmount || this.paymentAmount <= 0;
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  watch: {
    selectedPaymentInfo: {
      handler(newInfo) {
        if (newInfo && newInfo.id) {
          this.postData.user_payment_id = newInfo.id;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    handleSubmit() {
      // 0円での申請を防ぐフロントエンドバリデーション
      if (!this.paymentAmount || this.paymentAmount <= 0) {
        return; // 0円以下の場合は申請しない
      }
      this.postData.is_speed_payment = this.localQuickDeposit;
      this.$emit('submit', this.postData);
    },
    handleSave() {
      this.$emit('save', this.paymentData);
    },
    changeMethod(id) {
      this.postData.payment_type = id;
    },
    handleDeleteAccount() {
      this.mode = 'attention';
    },
    confirmDeleteAccount() {
      this.$emit('delete', this.selectedPaymentInfo.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay_conf {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .payment-modal {
    border: none;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 1);
    border-radius: 10px;
    width: 600px;
    max-height: 90%;
    overflow-y: auto;
    padding: 20px;
    position: relative;
    @media screen and (max-width: $tabletWidth) {
      width: 400px;
    }
    @media screen and (max-width: $mobileWidth) {
      width: 95vw;
      margin: 0 auto;
    }
    .modal-body,
    .modal-content {
      margin: 0 auto;
      width: 100%;
      margin: 10px auto;
      h2 {
        @media screen and (max-width: $mobileWidth) {
          font-size: 20px;
          margin-bottom: 15px;
        }
      }
      p {
        @media screen and (max-width: $mobileWidth) {
          font-size: 16px;
          line-height: 1.5;
        }
      }
      .payment-summary {
        padding: 10px 0;
        .summary-row {
          display: flex;
          justify-content: space-between;
          font-weight: bold;
          font-size: 20px;
          margin: 10px 0;
          &.app-amount {
            font-size: 17px;
          }
          .paypal-text {
            display: flex;
            align-items: center;
          }
          @media screen and (max-width: $mobileWidth) {
            font-size: 18px;
            &.app-amount {
              font-size: 16px;
            }
            .paypal-text {
              font-size: 12px;
            }
          }
        }
        .detail-row {
          font-size: 14px;
          color: $gray2;
          .detail-item {
            display: flex;
            justify-content: space-between;
            &.sub {
              border-bottom: 1px solid #ddd;
              padding: 5px 0;
            }
            .paypal-text {
              display: flex;
              align-items: center;
            }
          }
          @media screen and (max-width: $mobileWidth) {
            font-size: 16px;
            .paypal-text {
              font-size: 12px;
            }
          }
        }
      }
      .bank-info,
      .paypal {
        margin: 20px 0;
        select {
          width: 100%;
          padding: 8px;
          font-size: 15px;
          border: 1px solid #787878;
          border-radius: 5px;
          background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='10'%20height='10'%20viewBox='0%200%2010%2010'%3E%3Cpolygon%20points='0,0%2010,0%205,7'%20fill='%23999'%20/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 10px center;
          background-size: 10px 10px;
          @media screen and (max-width: $mobileWidth) {
            padding: 12px;
            font-size: 16px;
            min-height: 48px;
          }
        }
        .form-group {
          margin-bottom: 15px;
          label {
            font-size: 14px;
            margin-bottom: 5px;
            display: block;
            @media screen and (max-width: $mobileWidth) {
              font-size: 16px;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
    .info-header {
      display: flex;
      justify-content: flex-start;
      gap: 10px;
      align-items: center;
      margin-bottom: 4px;
      .section-title {
        @media screen and (max-width: $mobileWidth) {
          font-size: 16px;
          font-weight: bold;
        }
      }
      .delete-btn {
        background: none;
        border: none;
        color: #c00;
        cursor: pointer;
        border-radius: 10px;
        border: 1px solid #c00;
        padding: 2px 20px;
        font-size: 14px;
        &:hover {
          background: rgb(230, 230, 230);
        }
        @media screen and (max-width: $mobileWidth) {
          font-size: 14px;
          padding: 4px 16px;
          min-height: 32px;
        }
      }
    }
    .detail-info {
      padding: 10px 0;
    }
  }
}
.button-area {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  gap: 10px;
  padding-bottom: 10px;
  button {
    padding: 10px 0px;
    border: none;
    cursor: pointer;
    border-radius: 0;
    font-size: 16px;
    font-weight: bold;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  }
  .square-button {
    width: 50%;
    &.disabled {
      background: #ccc;
      color: #777;
      pointer-events: none;
      cursor: not-allowed;
    }
  }
  .cancel {
    width: 50%;
    color: #a1a2a2;
  }
}
</style>
